import React from 'react';
import { Col, Modal, Row } from "antd";
import { StatusRequestTimer } from "../statusRequestTimer";
import { Button } from '../../index';

import {
    SettingOutlined,
    CodeOutlined,
} from '@ant-design/icons'

const styleCols = { marginTop: '0px' }
const styleRow = { marginBottom: '0px', display: 'flex', justifyContent: 'end' }

export const ControlButtons = ({ plateSelected, serviceCmd, getStatusPlate, setModalCommandsVisible, setModalConfigurationsVisible, deviceStatus, listCommands, pauseTimer }) => {


    const handleCheckStatusDevice = (type) => {
        const statusDeviceEnable = deviceStatus.devicesHabilitado.substring(0, 1) === "0";
        const sizeListCommands = listCommands && listCommands.length > 0;
        if (statusDeviceEnable) {
            Modal.warning({
                closable: true,
                title: 'Dispositivos desabilitado!',
                content: (
                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                        <p>Os comandos e as configurações estão desabilitados.</p>
                        <p>Por favor, habilite os dispositivos para que as funções de envio de comandos e configurações possam ser ativadas.</p>
                    </div>
                ),
                width: '500px',
                onOk: type === 'settings' ? () => setModalConfigurationsVisible(false) : () => setModalCommandsVisible(true),
                okText: "Confirmar",
                cancelText: "Cancelar"
            });
        } else if (sizeListCommands) {
            const filterCommandsSetting = listCommands.filter((value) => value.cmdType.startsWith("$ST"));
            if (type === 'settings' && filterCommandsSetting && filterCommandsSetting.length > 0) {
                Modal.confirm({
                    closable: true,
                    title: 'Configuração em Andamento.',
                    content: (
                        <div style={{ display: 'flex', flexDirection: 'column' }}>
                            <p>Deseja sobrescrever a configuração em andamento?!</p>
                        </div>
                    ),
                    width: '500px',
                    onOk: type === 'settings' ? () => setModalConfigurationsVisible(true) : () => setModalCommandsVisible(true),
                    onCancel: type === 'settings' ? () => setModalConfigurationsVisible(false) : () => setModalCommandsVisible(false),
                    okText: "Confirmar",
                    cancelText: "Cancelar"
                });
            } else if (type === 'commands') {
                setModalCommandsVisible(true);
            }

        } else {
            if (type === 'settings') {
                setModalConfigurationsVisible(true);
            } else {
                setModalCommandsVisible(true);
            }
        }
    }

    return (
        <Row gutter={24} style={styleRow}>
            <Col style={styleCols}>
                <StatusRequestTimer plate={plateSelected} serviceCmd={serviceCmd} getStatusPlate={getStatusPlate} pauseTimer={pauseTimer} />
            </Col>
            <Col style={styleCols}>
                <Button
                    style={{ marginRight: "12px", width: '150px' }}
                    type='primary'
                    children='Comandos'
                    icon={<CodeOutlined />}
                    size={"small"}
                    onClick={() => handleCheckStatusDevice('commands')}
                />
            </Col>
            <Col style={styleCols}>
                <Button
                    style={{ width: '150px' }}
                    type='primary'
                    children='Configurações'
                    block
                    icon={<SettingOutlined />}
                    onClick={() => handleCheckStatusDevice('settings')}
                />
            </Col>
        </Row>
    );
}